import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    Switch,
    CardActions
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { useMemo } from "react";


export default function ActivationCard({
    status,
    onStatusUpdated,
    loading,
    error,
    isSuccess,
    price = false
}) {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false)
    const handleChange = (value) => {
        setChecked(value)
    }
    useEffect(() => {
        if (status === "ACTIVE") {
            setChecked(true)
        } else {
            setChecked(false)
        }

    }, [status])

    const onUpdateStatusHandlers = () => {
        if (checked) {
            onStatusUpdated("ACTIVE")
        } else {
            onStatusUpdated("BLOCKED")
        }
    }

    const disabledConfirm = useMemo(() => {
        let currentStatus = checked ? ["ACTIVE"] : ["WAITING", "BLOCKED", "CARD_REQUIRED", "PLAN_EXPIRED"]
        return currentStatus.includes(status)
    }, [checked, status])

    return (
        <Card>
            <CardHeader title={`${t("Status")} (${t(`USER_STATUS.${status}`)})`} />
            <Divider />
            <CardContent>
                <FormControlLabel
                    control={
                        <Switch
                            checked={checked}
                            onChange={({ target: { checked } }) => handleChange(checked)}
                            color="main"
                        />
                    }
                    label={t(checked ? "Activated" : "Not Activated")}
                />
                {
                    price &&
                    <>
                    
                    </>
                }
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={onUpdateStatusHandlers}
                    disabled={disabledConfirm}
                >{t("Confirm")}
                </LoadingButton>
                {!!isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

